<ngx-charts-chart
  [view]="[width, extendedHeight]"
  [showLegend]="false"
  [legendOptions]="legendOptions"
  [activeEntries]="activeEntries"
  [animations]="animations"
  (legendLabelActivate)="onActivate($event, undefined!, true)"
  (legendLabelDeactivate)="onDeactivate($event, undefined!, true)"
  (legendLabelClick)="onClick($event)"
  >
  <svg:g [attr.transform]="transform" class="bar-chart chart">
    <svg:g
      ngx-charts-grid-panel-series
      [xScale]="groupScale"
      [yScale]="valueScale"
      [data]="results"
      [dims]="dims"
      [orient]="barOrientation.Vertical"
      ></svg:g>
      @if (xAxis) {
        <svg:g
          ngx-charts-x-axis
          [xScale]="groupScale"
          [dims]="dims"
          [showLabel]="showXAxisLabel"
          [labelText]="xAxisLabel"
          [trimTicks]="trimXAxisTicks"
          [rotateTicks]="rotateXAxisTicks"
          [maxTickLength]="maxXAxisTickLength"
          [tickFormatting]="xAxisTickFormatting"
          [ticks]="xAxisTicks"
          [xAxisOffset]="dataLabelMaxHeight.negative"
          (dimensionsChanged)="updateXAxisHeight($event)"
          ></svg:g>
        }
        @if (yAxis) {
          <svg:g
            ngx-charts-y-axis
            [yScale]="valueScale"
            [dims]="dims"
            [showGridLines]="showGridLines"
            [showLabel]="showYAxisLabel"
            [labelText]="yAxisLabel"
            [trimTicks]="trimYAxisTicks"
            [maxTickLength]="maxYAxisTickLength"
            [tickFormatting]="yAxisFormat"
            [ticks]="yAxisTicks"
            (dimensionsChanged)="updateYAxisWidth($event)"
            ></svg:g>
          }
          @if (!isSSR) {
            <svg:g>
              @for (group of results; track trackBy(index, group); let index = $index) {
                <svg:g
                  ngx-charts-series-vertical
                  [attr.transform]="groupTransform(group)"
                  [activeEntries]="activeEntries"
                  [xScale]="innerScale"
                  [yScale]="valueScale"
                  [colors]="colorHelper"
                  [series]="getSeries(group)"
                  [dims]="dims"
                  [gradient]="gradient"
                  [tooltipDisabled]="tooltipDisabled"
                  [tooltipTemplate]="tooltipTemplate"
                  [showDataLabel]="showDataLabel"
                  [dataLabelFormatting]="dataLabelFormatting"
                  [seriesName]="group.name"
                  [roundEdges]="roundEdges"
                  [animations]="animations"
                  [noBarWhenZero]="noBarWhenZero"
                  (select)="onClick($event, group)"
                  (activate)="onActivate($event, group)"
                  (deactivate)="onDeactivate($event, group)"
                  (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, index)"
                  />
              }
              </svg:g>
            }

            <filter filterUnits="userSpaceOnUse" id="gblur">
              <feGaussianBlur in="src" stdDeviation="0" result="noblur"></feGaussianBlur>
              <feColorMatrix in="src" result="white" type="matrix"
                     values="0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 1 0" />
                <feGaussianBlur stdDeviation="1" in="white" result="blur1"></feGaussianBlur>
                <feGaussianBlur stdDeviation="2" in="white" result="blur2"></feGaussianBlur>
                <feGaussianBlur stdDeviation="3" in="white" result="blur3"></feGaussianBlur>
                <feGaussianBlur stdDeviation="4" in="white" result="blur4"></feGaussianBlur>
                <feGaussianBlur stdDeviation="5" in="white" result="blur5"></feGaussianBlur>
                <feMerge>
                  <feMergeNode in="blur1"></feMergeNode>
                  <feMergeNode in="blur2"></feMergeNode>
                  <feMergeNode in="blur3"></feMergeNode>
                  <feMergeNode in="blur4"></feMergeNode>
                  <feMergeNode in="blur5"></feMergeNode>
                  <feMergeNode in="noblur"></feMergeNode>
                </feMerge>
              </filter>

              <text id="price-text" style="font-size: 12px;" filter="url(#gblur)" [attr.fill]="priceColor"></text>
              <polygon id="price-line" (mousedown)="dragStart($event, 1)" (touchmove)="onTouchMove($event, 1)" (touchend)="onTouchEnd($event)" />

              <polygon style="fill:#58504e;stroke:none;" [attr.id]="'myContractArrow'" />
              <text style="color: #58504e; text-decoration: underline;font-size: 16px;font-weight: bold;" filter="url(#gblur)" [attr.id]="'myContractText'"></text>

              </svg:g>
              @if (isSSR) {
                <svg:g>
                  @for (group of results; track trackBy(index, group); let index = $index) {
                    <svg:g
                      ngx-charts-series-vertical
                      [attr.transform]="groupTransform(group)"
                      [activeEntries]="activeEntries"
                      [xScale]="innerScale"
                      [yScale]="valueScale"
                      [colors]="colorHelper"
                      [series]="getSeries(group)"
                      [dims]="dims"
                      [gradient]="gradient"
                      [tooltipDisabled]="tooltipDisabled"
                      [tooltipTemplate]="tooltipTemplate"
                      [showDataLabel]="showDataLabel"
                      [dataLabelFormatting]="dataLabelFormatting"
                      [seriesName]="group.name"
                      [roundEdges]="roundEdges"
                      [animations]="animations"
                      [noBarWhenZero]="noBarWhenZero"
                      (select)="onClick($event, group)"
                      (activate)="onActivate($event, group)"
                      (deactivate)="onDeactivate($event, group)"
                      (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, index)"
                      />
                  }
                  </svg:g>
                }
              </ngx-charts-chart>
              @if (datasetSelector) {
                <div class="checkbox-selector mt-10" style="margin-left: 0; margin-right: -70px;">
                  <label [class]="(selectedDatasets.includes(1))?'checked '+((selectedDatasets.length>1)?'input-with-x':''):''" style="font-size: 12px;"><input type="checkbox" name="termFrom" (change)="datasetChangedEmitter.next(1)" value="">vs {{utilityName}}</label>
                  <label [class]="(selectedDatasets.includes(2))?'checked '+((selectedDatasets.length>1)?'input-with-x':''):''" style="font-size: 12px;"><input type="checkbox" name="termFrom" (change)="datasetChangedEmitter.next(2)" value="">vs NextEra Energy</label>
                </div>
              }

              @if (legend) {
                <div class="chart-legend">
                  <ngx-charts-legend
                    [data]="legendData"
                    [colors]="colorHelper">
                  </ngx-charts-legend>
                  @if (utilityWarningDate!=null && utilityWarningDate!='') {
                    <div class="utility-chart-info utility-note">* {{utilityNameForWarning}} rate beyond {{utilityWarningDate}} is estimated and subject to adjustment</div>
                  }
                </div>
              }